<template>
  <div class="modal" :class="{ 'is-active': isActive }">
    <div class="modal-background" @click="$emit('update:isActive', false)"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Import Cloud Recording</p>
        <button 
          class="delete" 
          aria-label="close"
          @click="$emit('update:isActive', false)"
        ></button>
      </header>
      <section class="modal-card-body">
        <div class="content">
          <h4>Import Zoom Recordings</h4>
          <p class="help mb-4">Connect your Zoom account to import meeting recordings</p>
          
          <ZoomWrapper @refresh="handleMeetingCreated" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import ZoomWrapper from './ZoomWrapper.vue';

export default {
  name: 'CloudRecordingModal',
  components: {
    ZoomWrapper,
  },
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    handleMeetingCreated() {
      this.$emit('meeting-created');
      this.$emit('update:isActive', false);
    },
  },
};
</script>

<style scoped>
.modal-card {
  max-width: 480px;
}

.content {
  h4 {
    margin-bottom: 0.5rem;
  }
}
</style> 